import { useHasBillingManagementActive, useHasNFSeProductActive } from '@ibk/shared-config';
import { FeatureFlagUseCase } from '@ibk/shared-types';
import { useFeatureFlag } from '../useFeatureFlag/useFeatureFlag';
export const useNFSeAccess = (isAuthenticated, hasNfsePermission, isAuthorizationOwner) => {
    const { isFeatureFlagWhiteListed, isLoading: isLoadingFeatureFlags, error: featureFlagError, } = useFeatureFlag(undefined, {
        isLoggedIn: isAuthenticated,
    });
    const isNFSeModuleEnabled = !!isFeatureFlagWhiteListed(FeatureFlagUseCase.MODULE_BILLING_NFSE);
    const isNFSeStandaloneEnabled = !isLoadingFeatureFlags &&
        !featureFlagError &&
        !!isFeatureFlagWhiteListed(FeatureFlagUseCase.MODULE_BILLING_NFSE_STANDALONE);
    const { hasBillingActive: hasBillingManagementActive, isLoading: isLoadingBillingManagementActive, } = useHasBillingManagementActive();
    const { hasNFSeProductActive } = useHasNFSeProductActive();
    const hasStandaloneAccess = isAuthorizationOwner || hasNfsePermission === true;
    const canAccessNFSe = isNFSeModuleEnabled &&
        (isNFSeStandaloneEnabled ? hasStandaloneAccess : hasBillingManagementActive);
    const isLoadingNfsePermission = isNFSeStandaloneEnabled && !isAuthorizationOwner && hasNfsePermission === undefined;
    const isLoadingAccess = isLoadingFeatureFlags ||
        isLoadingNfsePermission ||
        (!isNFSeStandaloneEnabled && isLoadingBillingManagementActive);
    const shouldRedirectFromNFSe = !isLoadingAccess && !canAccessNFSe;
    return {
        isNFSeModuleEnabled,
        isNFSeStandaloneEnabled,
        hasBillingManagementActive,
        hasNFSeProductActive,
        isLoadingFeatureFlags,
        isLoadingBillingManagementActive,
        isLoadingAccess,
        canAccessNFSe,
        shouldRedirectFromNFSe,
    };
};
